import { alpha, brand } from '@/styles/shared';

export const headerStyles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: {
      xs: '6px 0px 16px 0px',
      lg: '16px 0px',
    },
    backgroundColor: '#ffffff',
    borderBottom: {
      xs: '1px solid #e0e0e0',
      sm: 'none',
    },
    width: '100%',
    boxSizing: 'border-box',
    flexWrap: {
      xs: 'wrap',
      sm: 'nowrap',
    },
    flexDirection: {
      xs: 'column',
      sm: 'row',
    },
    gap: {
      xs: '24px',
      sm: '0px',
    },
  },
  logo: {
    height: '40px',
    width: 'auto',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.7,
    },
  },
  actionsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '40px',
  },
  showHistoryButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    borderRadius: '8px',
    cursor: 'pointer',
    border: '1px solid transparent',
    color: '#333333',
    '@media (hover: hover) and (pointer: fine)': {
      '&:hover': {
        backgroundColor: alpha.purple05,
        border: `1px solid ${brand.purpleAccent}`,
        color: brand.purpleAccent,
      },
    },
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  showHistoryText: {
    fontSize: '14px',
    fontWeight: 500,
    color: 'inherit',
  },
};
